import slick from "slick-carousel";

export const ProductController = () => {

    enquire.register('(max-width:768px)', {
        match: () => {
            $('.overview-products').slick({
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 1,
            });
            
        },
        unmatch: () => {
            $('.overview-products').slick('unslick');
        },
    });

}



// WEBPACK FOOTER //
// ./src/js/controllers/ProductController.js